import MenuBookTwoToneIcon from '@mui/icons-material/MenuBookTwoTone';

export const uberEatsMenu = [
  {
    id: 0,
    name: 'Store Menu Manager',
    url: '/uber-eats/menu-manager',
    Icon: MenuBookTwoToneIcon,
  },
  {
    id: 2,
    name: 'Menu Modifiers',
    url: '/uber-eats/menu-modifiers',
    Icon: MenuBookTwoToneIcon,
  },
];

export const uberEatsAdminMenu = [
  {
    id: 0,
    name: 'Store Menu Manager',
    url: '/uber-eats/menu-manager',
    Icon: MenuBookTwoToneIcon,
  },
  {
    id: 1,
    name: 'Menu Creation',
    url: '/uber-eats/menu-creation',
    Icon: MenuBookTwoToneIcon,
  },
  {
    id: 2,
    name: 'Menu Modifiers',
    url: '/uber-eats/menu-modifiers',
    Icon: MenuBookTwoToneIcon,
  },
];
